import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { ApiLoginService } from './services/login/api-login.service';
import { ApiService } from './services/api.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'xmlVisio';

  usuarioLogado: any = {};
  usuarioAutenticado: boolean = false;
  versaoSistema:any = ''

  constructor(
    private apiLogin: ApiLoginService,
    public apiLoading: ApiService,
    private router: Router
  ) {}

  @HostListener('window:storage')
  onStorageChange() {
    this.getUsuarioStorage();
  }

  ngOnInit() {
    this.getUsuarioStorage();
    this.getVersao();
  }


  getVersao(){
    const _self = this;
    this.apiLogin.versaoXML()
    .then(versaoStorage => {
        if (versaoStorage != undefined) {
          _self.versaoSistema = versaoStorage;
        }
      })
      .catch(erro => {
        console.warn('app.component.ts - erro ao buscar usuario no datastorage: ', erro)
      })  
  }

  // getLoginStorage() {
  //   const _self = this;
  //   this.apiLogin.getLoginStorage()
  //     .then(loginStorage => {
  //       if (loginStorage != undefined) {
  //         this.getUsuarioStorage();
  //         _self.usuarioAutenticado = loginStorage.usuarioAutenticado;

  //         _self.apiLogin.mostraMenu.subscribe(
  //           show => _self.usuarioAutenticado = show
  //         )
  //       }
  //     })
  //     .catch(erro => {
  //       console.warn('app.component.ts - erro ao buscar login no datastorage: ', erro)
  //     })
  // }

  getUsuarioStorage() {
    const _self = this;
    this.apiLogin.getUsuarioStorage()
      .then(usuarioStorage => {
        if (usuarioStorage != undefined) {
          _self.usuarioLogado = usuarioStorage;
          _self.usuarioAutenticado = usuarioStorage.usuarioAutenticado;

          _self.apiLogin.mostraMenu.subscribe(
            show => _self.usuarioAutenticado = show
          )
        }
      })
      .catch(erro => {
        console.warn('app.component.ts - erro ao buscar usuario no datastorage: ', erro)
      })
  }
}
